/*
 * @Author: zd
 * @Date: 2023-10-01 02:10:50
 * @LastEditors: zd
 * @LastEditTime: 2023-12-01 13:34:26
 * @Description: 客户关联api
 */
import request from '@/utils/request.js'

// 登录
export function custLogin (data) {
  return request.post('/cust/login', data)
}
// 子账户登录
export function childLogin (data) {
  return request.post('/childCust/childLogin', data)
}
// 子账户登录获取验证码
export function sendCheckCode (data) {
  return request.post('/childCust/sendCheckCode', data)
}

// 客户信息统计
export function getStats (data) {
  return request.post('/cust/getStats', data)
}

// 持仓合同
export function getCustHoldOptionList (data) {
  return request.post('/cust/getCustHoldOptionList', data)
}

// 即将到期合同
export function getCustOptionCloseToEnd (data) {
  return request.post('/cust/getCustOptionCloseToEnd', data)
}

// 估值报告列表
export function getCustSettleFilePage (data) {
  return request.post('/cust/settle/getCustSettleFilePage', data)
}

// 资金明细
export function getAccountPassFlowList (data) {
  return request.post('/cust/balance/getAccountPassFlowList', data)
}

// 保证金
export function getCustDepositFilePage (data) {
  return request.post('/cust/deposit/getCustDepositFilePage', data)
}

// 历史合约
export function getCustCloseOptionPage (data) {
  return request.post('/cust/getCustCloseOptionPage', data)
}

export function getCustEquity (data) {
  return request.post('/cust/getCustEquity', data)
}

export function firstLogin (data) {
  return request.post('/cust/first-login', data)
}

export function changePassword (data) {
  return request.post('/cust/change_password', data)
}

export function genCheckCode (data) {
  return request.post('/cust/genCheckCode', data)
}

/**
 * @Description: 禁用子账户
 * @param {*} data
 */
export function unableChild (data) {
  return request.post('/childCust/unableChild', data)
}
/**
 * @Description:  期货赔付
 * @param {*} data
 */
export function getCustAutoPricingFutuInfoByContractSerial (data) {
  return request.post('/cust/getCustAutoPricingFutuInfoByContractSerial', data)
}
/**
 * @Description:  - 固定赔付
 * @param {*} data
 */
export function getCustFixedPayedBalanceByContractSerial (data) {
  return request.post('/cust/getCustFixedPayedBalanceByContractSerial', data)
}

